import GeozoneLogo from '../assets/svg/logo-geozone.svg'
import GeolocatorLogo from '../assets/svg/geolocator.svg'
import GeocommentLogo from '../assets/svg/geocomment.svg'
import ArcGISurbanLaunchKitLogo from '../assets/svg/arcgis-urban-launch-kit.svg'
import ArcGISHubLogo from '../assets/svg/arcgis-hub.svg'
import ArcGISDataHealthChecksLogo from '../assets/svg/arcgis-data-health-checks.svg'
import ArcGISBusinessAnalystLogo from '../assets/svg/arcgis-business-analyst.svg'
import GISLaunchKit3dLogo from '../assets/svg/3d-gis-launch-kit.svg'
import ArcGISLaunchKitLogo from '../assets/svg/arcgis-launch-kit.svg'
import ArcGISEnterpriseLaunchKitLogo from '../assets/svg/arcgis-enterprice-launch-kit.svg'
import ArcGISEnterpriceCloudLaunchKitLogo from '../assets/svg/arcgis-enterprice-cloud-launch-kit.svg'
import FieldOperationslaunchKitLogo from '../assets/svg/field-operations-launch-kit.svg'
import ArcGISUtilityNetworkLogo from '../assets/svg/arcgis-utility-network.svg'
export function getDashBoardData() {

    return [
        {
            logo: GeozoneLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "C",
                    cardhover: "Communications"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Easy",
            features:
                [
                    <>Built <strong>around</strong> Planners’ needs</>,
                    <>Accurately <strong>analyze</strong> and review Zoning ordinances</>,
                    <>Custom tools - Land use and Zoning look-up functionality</>
                ],
            learnMoreLink: "https://www.viewprogis.com/geozone",
            demoLink: "https://map.viewprogis.com/demo/cc-fl?widget=334ea888-74a3-4dd5-bca2-cd9460cca91b",
            IDList: "geozone"
        },

        {
            logo: ArcGISurbanLaunchKitLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "C",
                    cardhover: "Communications"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Easy",
            features:
                [
                    <>A <strong>Site-Selection</strong> tool to aide Economic Development</>,
                    <>Provides <strong>real-time access</strong> to Esri curated data and reports</>,
                    <>Access to 3rd party commercial listings for sale/leasey</>
                ],
            learnMoreLink: "https://www.viewprogis.com/arcgis-urban-deployment",
            demoLink: "https://urban.arcgis.com/?id=e120bcbd6f7b4250acff9bd16630dd48",
            IDList: "urban-launch-kit"
        },
        {
            logo: GeocommentLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "C",
                    cardhover: "Communications"
                },
            ],
            diffultyLevel: "Easy",
            features:
                [
                    <>Map based and highly intuitive <strong>Citizen Engagement tool</strong></>,
                    <><strong>Secured curation</strong> of the incoming feedback</>,
                    <>Easy to use interface, requires little or no technical training</>,
                ],
            learnMoreLink: "https://www.viewprogis.com/geocomment",
            demoLink: "https://maps.viewprogis.com/vp/US67-test",
            IDList: "geocomment"

        },

        {
            logo: ArcGISHubLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "C",
                    cardhover: "Communications"
                },
            ],
            diffultyLevel: "Medium",
            features:
                [
                    <>Offers advanced tools to engage with the audience</>,
                    <>Create &amp; manage multiple planning initiatives </>,
                    <>Integrate event management and surveys all in one platform</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/arcgis-hub/overview",
            demoLink: "https://edc-b-borger.hub.arcgis.com/",
            IDList: "arcgis-hub"
        },
        {
            logo: GeolocatorLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Easy",
            features:
                [
                    <>A <strong>Site-Selection</strong> tool to aide Economic Development</>,
                    <>Provides <strong>real-time access</strong> to Esri curated data and reports</>,
                    <>Access to 3rd party commercial listings for sale/leasey</>
                ],
            learnMoreLink: "https://www.viewprogis.com/geolocator",
            demoLink: "https://maps.viewprogis.com/ecp/richmondedc-tx",
            IDList: "geolocator"
        },
        {
            logo: ArcGISBusinessAnalystLogo,
            departments:[
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Medium",
            features:
                [
                    <>Help make informed data driven decisions for Site Selction and market planning</>,
                    <>Access to curated reports for demographics, lifestyle, spending and census data</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/arcgis-business-analyst/overview",
            demoLink: "https://www.esri.com/en-us/arcgis/products/arcgis-business-analyst/overview",
            IDList: "business-analyst"
        },
        {
            logo: GISLaunchKit3dLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Advanced",
            features:
                [
                    <>Create detailed 3D building context using LiDar files</>,
                    <>Create as-built environment to conceptualize your vision</>,
                    <>See patterns and trends using 3D contextual data models</>
                ],
            learnMoreLink: "https://storymaps.arcgis.com/stories/f988bfdb6baa43d49156ba91facb300f",
            demoLink: "https://map.viewprogis.com/ecp/crm-nc",
            IDList: "3d-launch-kit"
        },
        {
            logo: ArcGISDataHealthChecksLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                }
            ],
            diffultyLevel: "Medium",
            features:
                [
                    <>Performs a data diagnostic to achieve consistent quality</>,
                    <>Automatic detection of issues such as feature integrity and spatial inaccuracies</>,
                    <>Achieve consistent data quality</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/arcgis-data-reviewer/overview",
            demoLink: "https://www.esri.com/en-us/arcgis/products/arcgis-data-reviewer/overview",
            IDList: "data-health-checks"
        },

        {
            logo: ArcGISLaunchKitLogo,
            departments: [
                {
                    cardname: "PZ",
                    cardhover: "Planning & Zoning"
                },
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                },
                {
                    cardname: "UD",
                    cardhover: "Urban Design"
                },
                {
                    cardname: "C",
                    cardhover: "Communications"
                },
                {
                    cardname: "ED",
                    cardhover: "Economic Development"
                }
            ],
            diffultyLevel: "Medium",
            features:
                [
                    <>Enables 3D decision making</>,
                    <>Helps you to decipher complex zoning ordinance with ease and accuracy</>
                ],
            learnMoreLink: "https://www.arcgis.com/apps/Cascade/index.html?appid=c7ae358cb923443fb3e61f49c86bdbc9",
            demoLink: "https://www.arcgis.com/apps/Cascade/index.html?appid=c7ae358cb923443fb3e61f49c86bdbc9",
            IDList: "online-launch-kit"
        },
        {
            logo: ArcGISEnterpriseLaunchKitLogo,
            departments: [
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                }
            ],
            diffultyLevel: "Advanced",
            features:
                [
                    <>Advanced GIS foundation that support work behind a firewall and on premise</>,
                    <>Add special server extensions to optimize your needs</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/arcgis-enterprise/overview",
            demoLink: "https://www.esri.com/en-us/arcgis/products/arcgis-enterprise/overview",
            IDList: "enterprise-launch-kit"
        },
        {
            logo: ArcGISEnterpriceCloudLaunchKitLogo,
            departments: [
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                }
            ],
            diffultyLevel: "Advanced",
            features:
                [
                    <>Advanced GIS foundation that support work behind a firewall and on a cloud</>,
                    <>A complete kit to kickstart your cloud based Enterprise solution</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/landing-page/industry/government/2019/small-local-government-cbea",
            demoLink: "https://www.esri.com/en-us/landing-page/industry/government/2019/small-local-government-cbea",
            IDList: "enterprise-cloud-launch-kit"
        },
        {
            logo: FieldOperationslaunchKitLogo,
            departments: [
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                }
            ],
            diffultyLevel: "Medium",
            features:
                [
                    <>Replace paper processes with with a configurable single app</>,
                    <>Real-time location awareness</>,
                    <>All-in-one app to help field workers with data collection, editing and finding assets</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/field-operations/overview",
            demoLink: "https://www.esri.com/en-us/arcgis/products/field-operations/overview",
            IDList: "field-operation-launch-kit"
        },
        {
            logo: ArcGISUtilityNetworkLogo,
            departments:  [
                {
                    cardname: "PW",
                    cardhover: "Public Works"
                },
                {
                    cardname: "GIS",
                    cardhover: "GIS / IT"
                }
            ],
            diffultyLevel: "Advanced",
            features:
                [
                    <>Capture the operational requirements of utility assets</>,
                    <>Model operation and maintain network integrity</>,
                    <>Model utility assets at the right scale to match your needs</>
                ],
            learnMoreLink: "https://www.esri.com/en-us/arcgis/products/arcgis-utility-network/overview",
            demoLink: "https://www.esri.com/en-us/arcgis/products/arcgis-utility-network/overview",
            IDList: "utility-network"
        }
    ];
}